import Feature from 'ol/Feature';

import { LineModel } from './line_model';

export class BoulderModel {
    #feature: Feature;
    #name: string;
    #lines: LineModel[] | null;
    #thumbnail: string | null;

    constructor(feature: Feature) {
        this.#feature = feature;

        const lines = feature.get('lines');
        if (lines) {
            this.#lines = new Array<LineModel>();
            for (const line of lines) {
                this.#lines.push(new LineModel(line, this));
            }
        }
        else {
            this.#lines = null;
        }
        if (!this.#feature.get('name')) {
            throw new Error('Boulder feature must have a name property');
        }
        this.#name = this.#feature.get('name');

        if (this.#feature.get('thumbnail')) {
            this.#thumbnail = this.#feature.get('thumbnail');
        }
        else {
            this.#thumbnail = null;
        }
    }

    get name() {
        return this.#name;
    }

    get feature() {
        return this.#feature;
    }

    get lines() {
        return this.#lines;
    }

    get thumbnail() {
        return this.#thumbnail;
    }
}